import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var createConfigValueProvider = function createConfigValueProvider(configKey, canonicalEndpointParamKey, config) {
  var configProvider = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _config$configKey;
      var configValue;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              configValue = (_config$configKey = config[configKey]) !== null && _config$configKey !== void 0 ? _config$configKey : config[canonicalEndpointParamKey];
              if (!(typeof configValue === "function")) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", configValue());
            case 3:
              return _context.abrupt("return", configValue);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function configProvider() {
      return _ref.apply(this, arguments);
    };
  }();
  if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _credentials$credenti;
      var credentials, configValue;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof config.credentials === "function")) {
                _context2.next = 6;
                break;
              }
              _context2.next = 3;
              return config.credentials();
            case 3:
              _context2.t0 = _context2.sent;
              _context2.next = 7;
              break;
            case 6:
              _context2.t0 = config.credentials;
            case 7:
              credentials = _context2.t0;
              configValue = (_credentials$credenti = credentials === null || credentials === void 0 ? void 0 : credentials.credentialScope) !== null && _credentials$credenti !== void 0 ? _credentials$credenti : credentials === null || credentials === void 0 ? void 0 : credentials.CredentialScope;
              return _context2.abrupt("return", configValue);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }
  if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _credentials$accountI;
      var credentials, configValue;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(typeof config.credentials === "function")) {
                _context3.next = 6;
                break;
              }
              _context3.next = 3;
              return config.credentials();
            case 3:
              _context3.t0 = _context3.sent;
              _context3.next = 7;
              break;
            case 6:
              _context3.t0 = config.credentials;
            case 7:
              credentials = _context3.t0;
              configValue = (_credentials$accountI = credentials === null || credentials === void 0 ? void 0 : credentials.accountId) !== null && _credentials$accountI !== void 0 ? _credentials$accountI : credentials === null || credentials === void 0 ? void 0 : credentials.AccountId;
              return _context3.abrupt("return", configValue);
            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  }
  if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var endpoint, protocol, hostname, port, path;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return configProvider();
            case 2:
              endpoint = _context4.sent;
              if (!(endpoint && typeof endpoint === "object")) {
                _context4.next = 9;
                break;
              }
              if (!("url" in endpoint)) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", endpoint.url.href);
            case 6:
              if (!("hostname" in endpoint)) {
                _context4.next = 9;
                break;
              }
              protocol = endpoint.protocol, hostname = endpoint.hostname, port = endpoint.port, path = endpoint.path;
              return _context4.abrupt("return", "".concat(protocol, "//").concat(hostname).concat(port ? ":" + port : "").concat(path));
            case 9:
              return _context4.abrupt("return", endpoint);
            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  }
  return configProvider;
};